import { MdClose } from "react-icons/md";

export const TeamAndConditionsModel = ({
  setTeamConditionModal,
}) => {
  return (
    <>
      <div className="bg-black fixed top-0 left-0 right-0 w-full h-full z-50 bg-opacity-50">
        <div className="bg-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-xl rounded-[10px] w-[90%] sm:w-[450px] md:w-[500px] lg:w-[600px] flex flex-col max-h-[70vh] md:max-h-[50vh]">
          {/* Header */}
          <div className="rounded-t-2xl px-5 md:px-3 xl:px-5 py-2 xl:py-3 font-Poppins text-xl flex justify-between items-center flex-shrink-0">
            <div className="text-[18px] xl:text-xl text-gray-900">
              Terms & Conditions & Refund Policy
            </div>
            <button onClick={() => setTeamConditionModal(false)}>
              <MdClose className="text-gray-500 text-2xl hover:text-black" />
            </button>
          </div>
          <hr />

          {/* Scrollable Content */}
          <div
            className="px-4 py-6 sm:px-6 lg:px-8 overflow-y-auto flex-1"
            >
            <p>
              {" "}
              By proceeding with the payment, you agree to avail the Global
              Doctor-on-Call (G-DoC) Service offered by WelcomeCure. Payments
              are securely processed via Razorpay or any other payment gateways
              that the company may choose to integrate with its platform from
              time-to-time.
            </p>
            <br/>
            <br/>
            <p>
              1. Refund Eligibility A full refund can be requested before the
              doctor consultation has started and by assigning a valid or
              acceptable reason. Once the consultation begins, the service will
              be considered delivered and the payment will be non-refundable
              under any circumstances whatsoever. If you are unable to avail the
              consultation due to a lapse from our end, you are eligible for a
              100% refund.
            </p>
            <br/>
            <br/>
            <p>
              {" "}
              2. Payment Failures & Duplicate Charges In case your transaction
              fails but the amount is debited from your account, Razorpay will
              automatically reverse the amount to your original payment method
              within 5–7 working days. If any duplicate payment is detected, the
              extra amount will be refunded within 5–7 working days.
            </p>
            <br/>
            <br/>
            <p>
              3. Cancellation by User You will be asked to provide a valid and
              justified reasoning for requesting a refund by using the refund
              request link from WelcomeCure platform. Cancellations requested
              after the consultation has started or completed will not be
              eligible for refund.
            </p>
            <br/>
            <br/>
            <p>
              4. Refund Processing Timeline All approved refunds will be
              processed within a maximum of 14 business working days and
              credited back to the same payment method used at the time of
              booking or on any other requested payment method via an official
              reauest. The timeline may vary depending on your bank or payment
              provider.
            </p>
            <br/>
            <br/>
            <p>
              5. Company Rights WelcomeCure reserves the right to deny a refund
              request if there is evidence of misuse, abuse of the service, or
              violation of our terms or any other reason found to be
              unreasonable or unjustified by the user.
            </p>
            <br/>
            <br/>
            <p>
              Any disputes related to payments or refunds will be handled in
              accordance with Indian laws and under the jurisdiction of Mumbai
              courts.
            </p>
            <br/>
            <br/>
          </div>
        </div>
      </div>
    </>
  );
};
